import { RADIO_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { CREDIT_AMOUNT_TYPE_FIXED, CREDIT_AMOUNT_TYPE_PERCENT } from "@utils/CreditAmount";

export const CREDIT_AMOUNT_TYPE_OPTIONS = {
    [CREDIT_AMOUNT_TYPE_FIXED]: "Monto",
    [CREDIT_AMOUNT_TYPE_PERCENT]: "Porcentaje",
}

const CreditAmountFormConfig = {
    submit: {
        label: "Agregar Monto a Favor"
    },
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "hidden",
                        "name": "currencyId",
                    },
                    {
                        "type": "hidden",
                        "name": "exchange_rate",
                    },
                ],
                [
                    {
                        "type": "date",
                        "name": "fecha",
                        "label": "Fecha",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 5
                        },
                        // La fecha se sigue con onDateChange y se valida en el submit:
                        // `resetFormValue` no la deja en el estado que valida el DynamicForm.
                    },
                ],
                [
                    {
                        "type": RADIO_INPUT_TYPE,
                        "name": "tipo",
                        "label": "Aplicar por",
                        "isHorizontal": true,
                        "isHorizontalValues": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 9
                        },
                        "options": CREDIT_AMOUNT_TYPE_OPTIONS,
                        "defaultValue": CREDIT_AMOUNT_TYPE_FIXED,
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "money",
                        "name": "valor",
                        "isDecimal": true,
                        "step": "0.01",
                        "min": "0.01",
                        "label": "Monto",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 5
                        },
                        // El monto se valida en el submit con validateCreditAmount,
                        // que necesita el saldo pendiente de los documentos.
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "descripcion",
                        "label": "Descripcion",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 3
                        },
                        "sizing": {
                            "sm": 9
                        },
                        "defaultValue": "Saldo a favor",
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
            ]
        }
    ]
}

export default CreditAmountFormConfig;
